import { render, staticRenderFns } from "./assessment.vue?vue&type=template&id=6fe8368c&"
import script from "./assessment.vue?vue&type=script&lang=ts&"
export * from "./assessment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports